import { Box } from '@mui/material';
import HeaderNotifications from './Notifications';

function HeaderButtons() {
  return (
    <Box sx={{ mr: 1 }}>
      {/* <HeaderSearch /> */}
      <Box sx={{ mx: 0 }} >
        <HeaderNotifications />
      </Box>
    </Box>
  );
}

export default HeaderButtons;
